module.exports = __webpack_public_path__ + "static/media/violet.b240f1e3.png";